const commonRegex = require(`./commonRegex`);

exports.isValidIndianMobileNumber = (mobileNumber = null) => {
    return mobileNumber && String(mobileNumber) && String(mobileNumber).match(commonRegex.indianMobileNumberRegex);
};

// /**
//  * @function
//  * @description Validates whether provided value is a String and is truthy
//  * @param {string} str Value to validate as a truthy String
//  * @returns {boolean}
//  */
exports.isTruthyString = (str = ``) => {
    return Boolean(str && typeof str === `string` && str.trim());
};

exports.isValidEmailAddress = (emailAddress = null) => {
    return emailAddress && String(emailAddress) && String(emailAddress).match(commonRegex.emailAddressRegex);
};

exports.isValidPassword = (password = null) => {
    return (password
        && String(password)
        && String(password).match(commonRegex.passwordRegex));
}

// exports.isFetchRequest = (req) => {
//     return Boolean(
//         (req.query[`fetch-req`] && Boolean(req.query[`fetch-req`]))
//         || (req.headers[`fetch-req`] && Boolean(req.headers[`fetch-req`]))
//         || (req.body[`fetch-req`] && Boolean(req.body[`fetch-req`]))
//         || req.xhr
//     );
// }

// exports.JSONResponseStatus = (statusText=null) => {
//     if(typeof statusText !== `string`) return new Error(`Invalid data-type of status-text`);

//     const lowerCasedStatusText = statusText.trim().toLowerCase();

//     const isSuccess = Boolean(lowerCasedStatusText === `success`),
//         isFailure = Boolean(lowerCasedStatusText === `fail`),
//         isError = Boolean(lowerCasedStatusText === `error`);

//     return { isSuccess, isFailure, isError }
// }

// exports.isAcceptableImageFormat = (format=null) => {
//     if(format && (typeof format === `string`) && format.trim()){
//         const acceptableFormatsRegex = /(jpe?g|png)$/ig;

//         return Boolean(format.match(acceptableFormatsRegex));
//     }
// }

// exports.validateAndCreateAddressObj = (obj=null) => {
//     const missingMandatoryData = [];

//     if(obj && (typeof obj === `object`) && Object.keys(obj).length){
//         if(!obj.line_1) missingMandatoryData.push(`address`);
//         if(!obj.city) missingMandatoryData.push(`city`);
//         if(!obj.state) missingMandatoryData.push(`state`);
//         if(!obj.zipcode) missingMandatoryData.push(`pincode`);

//         if(missingMandatoryData.length){
//             return {
//                 error: { message: `You missed filling your ${ missingMandatoryData.join(`, `) }` }
//             }
//         }

//         if(!(obj.zipcode && obj.zipcode.match(commonRegex.indianAreaPincodeRegex))){
//             return {
//                 error: { message: `Invalid Indian Pincode` }
//             }
//         }

//         return { success: true }
//     }
//     else return {
//         error: { message: `Please provide all data` }
//     }
// }

// exports.isValidDate = (date=null) => {
//     const dateObj = new Date(date);

//     if(dateObj.getTime() - dateObj.getTime() === 0) return true;
//     else return false;
// }

exports.india = {
    /**
     * @method
     * @description Evaluates whether value is a valid Indian GST Identification Number
     * @param {string} gstin Value to validate as a valid Indian GST Identification Number
     * @returns {boolean}
     */
    gstin: (gstin = null) => {
        const stringifiedGSTIN = String(gstin);

        return Boolean(gstin && stringifiedGSTIN && stringifiedGSTIN.match(commonRegex.govtID.india.gstin));
    },

    isValidPincode: (pincode = null) => {
        const stringifiedPincode = String(pincode);

        return Boolean(pincode && stringifiedPincode && stringifiedPincode.match(commonRegex.pincode.india));
    },

    /**
     * @method
     * @description Evaluates whether value is a valid Indian PAN ID
     * @param {string} pan Value to validate as a valid Indian PAN ID
     * @returns {boolean}
     */
    pan: (pan = null) => {
        const stringifiedPAN = String(pan);

        return Boolean(pan && stringifiedPAN && stringifiedPAN.match(commonRegex.govtID.india.pan));
    },

    /**
     * @method
     * @description Evaluates whether value is a valid Indian Aadhar Number
     * @param {number|string} aadhar Value to validate as a valid Indian Aadhar Number
     * @returns {boolean}
     */
    aadhar: (aadhar = null) => {
        const stringifiedAadhar = String(aadhar);

        return Boolean(aadhar && stringifiedAadhar && stringifiedAadhar.match(commonRegex.govtID.india.aadhar));
    }
};

exports.isValidURL = (string) => {
    var res = string.match(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi);
    return (res !== null);
};

exports.isValidYoutubURL = (url) => {
  try {
      const parsedUrl = new URL(url);
      return (parsedUrl.hostname === "www.youtube.com" || parsedUrl.hostname === "youtube.com" || parsedUrl.hostname === "youtu.be");
  } catch (error) {
      return false; // URL parsing failed, hence not a valid YouTube URL
  }
};
// exports.isValidFacebookVideoURL = (string) => {
//     const regex = /^(?:https?:\/\/)?(?:www\.)?(?:facebook\.com|fb\.gg)\/(.*?)\/videos\/(?:[^\/]*\/)?([0-9]+)/i;
//     return regex.test(string);
//   };

  exports.isValidFacebookVideoURL = (string) => {
    const regex = /^(?:https?:\/\/)?(?:www\.)?facebook\.com\/.*\/videos\/(?:[^/]*\/)?([0-9]+)/i;
    return regex.test(string);
  };
  

//   function validateFacebookLiveURL(url) {
//     const regex = /^(?:https?:\/\/)?(?:www\.)?(?:facebook\.com|fb\.gg)\/(.*?)\/videos\/(?:[^\/]*\/)?([0-9]+)/i;
//     return regex.test(url);
//   }


// function validateInstagramLiveURL(url) {
//     const regex = /^(?:https?:\/\/)?(?:www\.)?instagram\.com\/(live\/\?r=([0-9]+))$/;

//   return regex.test(url);
// }

exports.isValidInstagramVideoURL = (string) => {
  const regex = /^https?:\/\/(?:www\.)?instagram\.com\/p\/[A-Za-z0-9-_]+\/?\??(?:igshid=[A-Za-z0-9_-]+)?$/;
  console.log(`vhgwfewhq qwhgegqw ehgwqceywqceqw eqywtceyqw eqwytcewq eqwytceqw eqweyqweqweyqw `, regex.test(string))
  return regex.test(string);
};

  exports.isValidZoomVideoURL = (string) => {
    const zoomLiveVideoRegex = /https:\/\/[\w-]*\.?zoom.us\/(j|my)\/[\d\w?=-]+/g;
    return zoomLiveVideoRegex.test(string);
  };

  exports.isValidTiktokVideoURL = (string) => {
    const tiktokLiveRegex = /^https?:\/\/(?:www\.)?tiktok\.com\/@[\w.-]+\/video\/(\d+)/i;
    // const regex = /^(?:https?:\/\/)?(?:www\.)?tiktok\.com\/(?:v|@[\w.-]+\/video)\/(\d+)(?:\?[^#\r\n]*)?(?:#[^\r\n]*)?$/;
    const res = string.match(tiktokLiveRegex);
    return res !== null;
  };
  
  exports.validateTeamsVideoCallUrl=(url)=> {
    // Regex pattern for Teams video call URL
    const regex = /^https:\/\/teams\.live\.com\/meet\/\d+$/;
    return regex.test(String(url));
  }
  
  exports.isValidGoogleMeetURL=(url)=> {
    const regex = /^https:\/\/meet\.google\.com\/[a-z0-9-]+$/i;
    return regex.test(url);
  }
  
exports.isValidBoolean = (str = ``) => {
    return Boolean(str && (typeof str === `boolean`));
}


exports.isDescriptionHas5Words =(htmlString =``) =>{

      let text = htmlString.replace(/<[^>]*>|&[^;]+;/g, ' ');

      // Trim and split the text into words
      let words = text.trim().split(" ");

      const filteredWord = words.filter(word => word.trim() !== '');

      return filteredWord.length < 5

}

exports.WordCount =(htmlString =``) =>{

  let text = htmlString.replace(/<[^>]*>|&[^;]+;/g, ' ');

  // Trim and split the text into words
  let words = text.trim().split(" ");

  const filteredWord = words.filter(word => word.trim() !== '');
  return filteredWord.length

}